import { c as _c } from "react/compiler-runtime";
import type { FC } from 'react';
export const Stack: FC = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <><path d="M21 3H11V13H21V3Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /><path d="M17 13V17H7V7H11" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /><path d="M13 17V21H3V11H7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};